
const initialState = {
    emails: JSON.parse(localStorage.getItem("emails")) || {},
    sms: JSON.parse(localStorage.getItem("sms")) || {},
    phones: JSON.parse(localStorage.getItem("phones")) || {},
    allEmail: [],
    allSearch:[],
    allSms:[],
    searchSms:[],
    allPhones:[],
    searchPhone:[],
    message: [],
    getAllUserListChat: [],
    error: null,
    selected_user_chat: [],
    user_chat_count: [],
    chat_search_result: [],
    total_message_count: [],
    smsTemplates: JSON.parse(localStorage.getItem("smsTemplates")) || [],
    selected_customer: [],
  };

  const communicationReducer = (state = initialState, action) => {
    switch (action.type) {
      case "GET_EMAIL_SUCCESS":
        return { ...state, allEmail: action.payload, error: null };
      case "GET_SMS_SUCCESS":
        return { ...state, allSms: action.payload, error: null };

      case "GET_CUSTOMER_NUMBER_SUCCESS":
        return { ...state, selected_customer: action.payload, error: null };
        
        case "GET_ALL_CHAT_USER_LIST_SUCCESS":

  return { 
    ...state, 
    getAllUserListChat: Array.isArray(action.payload?.content) 
      ? action.payload.content // If `content` exists and is an array, use it
      : Array.isArray(action.payload) 
        ? action.payload // If `content` is missing but response is an array, use response
        : [], // Otherwise, fallback to an empty array
    error: null 
  };

        case "CHAT_MEESAGE_SEARCH_SUCCESS":
        return { ...state, chat_search_result: action.payload, error: null };
        case "TOTAL_MEESAGE_COUNT_SUCCESS":
         return { ...state, total_message_count: action.payload || 0, error: null };
        case "CLEAR_TOTAL_COUNT_SUCCESS":
        return { ...state, total_message_count: action.payload, error: null };         
         
        
        case "GET_SELECTED_USER_CHAT_SUCCESS":
          return { ...state, selected_user_chat: action.payload, error: null };

          case "GET_CHAT_USER_COUNT_SUCCESS":
          return { ...state, user_chat_count: action.payload, error: null };

          case "UNREAD_COUNT_SUCCESS":
            return { ...state, user_chat_count: action.payload, error: null };
          
      case "GET_PHONE_SUCCESS":
        return { ...state, allPhones: action.payload, error: null };
      case "SEARCH_EMAIL_SUCCESS":
        return { ...state, allSearch: action.payload, error: null };
      case "SEARCH_SMS_SUCCESS":
        return { ...state, searchSms: action.payload, error: null };
      case "SEARCH_PHONE_SUCCESS":
        return { ...state, searchPhone: action.payload, error: null };
      case "SAVE_EMAIL_SUCCESS":
        localStorage.setItem("emails", JSON.stringify(action.payload));
        return { ...state, emails: action.payload, error: null };
      case "SAVE_SMS_SUCCESS":
        localStorage.setItem("sms", JSON.stringify(action.payload));
        return { ...state, sms: action.payload, error: null };
      case "GET_SMS_TEMPLATES_SUCCESS":
        localStorage.setItem("smsTemplates", JSON.stringify(action.payload));
        return { ...state, smsTemplates: action.payload, error: null };
      case "SAVE_COMMENT_SUCCESS":
        localStorage.setItem("comment", JSON.stringify(action.payload));
        return { ...state, comment: action.payload, error: null };
      case "UPDATE_NOTE_SUCCESS":
        localStorage.setItem("notes", JSON.stringify(action.payload));
        return { ...state, notes: action.payload, error: null };
        case "SEND_MESSAGE_SUCCESS":
          return { ...state, message: action.payload, error: null }; 
      case "DELETE_NOTE_SUCCESS":
        const updatedNote = state.allNote.filter(
          (policy) => policy.id !== action.payload
        );
        return { ...state, allNote: updatedNote, error: null };
      case "GET_EMAIL_FAILURE":
      case "GET_SMS_FAILURE":
      case "SAVE_EMAIL_FAILURE":
      case "SAVE_SMS_FAILURE":
      case "SAVE_SMS_TEMPLATES_FAILURE":
      case "SEARCH_EMAIL_FAILURE":
      case "SAVE_PHONE_FAILURE":
      case "DELETE_EMAIL_FAILURE":
      case "UPDATE_EMAIL_FAILURE":
      case "SEND_MESSAGE_FAILURE":
        return { ...state, error: action.payload };
      default:
        return state;
    }
  };

  export default communicationReducer;
